class EcBrFormModal extends HTMLElement {
  constructor() {
    super();
    
    const overlay = this.querySelector('.ec-br-form-modal__overlay');
    const closeButton = this.querySelector('.ec-br-form-modal__close');
    
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }
    
    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') {
        this.close();
      }
    });
  }

  connectedCallback() {
    this.setAttribute('hidden', '');
  }

  open() {
    this.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');
    const drawer = this.querySelector('.ec-br-form-modal__drawer');
    if (drawer) {
      drawer.focus();
    }
  }

  close() {
    this.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
    const triggerButton = document.querySelector('[data-modal-trigger="ec-modal-br"]');
    if (triggerButton) {
      triggerButton.focus();
    }
  }
}

customElements.define('ec-br-form-modal', EcBrFormModal);

let isInitialLoad = true;

function checkVariantStock(variant) {
  if (!variant) return;
  
  const modal = document.getElementById('ec-modal-br');
  if (!modal) return;

  const productInfo = document.querySelector('product-info');
  if (!productInfo) return;

  const isAvailable = variant.available === true || variant.available === 'true';
  
  productInfo.dataset.hasStock = isAvailable ? 'true' : 'false';
  
  if (isInitialLoad) {
    isInitialLoad = false;
    return;
  }
  
  if (!isAvailable) {
    if (typeof modal.open === 'function') {
      modal.open();
    }
  } else {
    if (typeof modal.close === 'function' && !modal.hasAttribute('hidden')) {
      modal.close();
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  function initModalTriggers() {
    const modal = document.getElementById('ec-modal-br');
    if (!modal) return;

    function setupButtonTrigger(button) {
      if (!button) return;
      
      const buttonText = button.querySelector('span')?.textContent?.trim() || button.textContent?.trim() || '';
      const isSoldOut = button.hasAttribute('disabled') && (
                        buttonText === (window.variantStrings?.soldOut || 'Sold out') ||
                        buttonText === 'Esgotado' ||
                        buttonText.includes('Sold out') ||
                        buttonText.includes('Esgotado')
                      );
      
      if (isSoldOut) {
        button.setAttribute('data-modal-trigger', 'ec-modal-br');
        button.setAttribute('type', 'button');
        button.removeAttribute('disabled');
        
        const existingHandler = button.getAttribute('data-modal-handler-attached');
        if (!existingHandler) {
          button.setAttribute('data-modal-handler-attached', 'true');
          button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof modal.open === 'function') {
              modal.open();
            }
          });
        }
      } else {
        button.removeAttribute('data-modal-trigger');
        button.removeAttribute('data-modal-handler-attached');
      }
    }

    const triggerButtons = document.querySelectorAll('[data-modal-trigger="ec-modal-br"]');
    triggerButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        if (typeof modal.open === 'function') {
          modal.open();
        }
      });
    });

    function checkAllSubmitButtons() {
      const submitButtons = document.querySelectorAll('[id^="ProductSubmitButton-"]');
      submitButtons.forEach(setupButtonTrigger);
    }

    checkAllSubmitButtons();

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        setTimeout(checkAllSubmitButtons, 100);
      });
    }

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
          const button = mutation.target;
          if (button.id && button.id.startsWith('ProductSubmitButton-')) {
            setupButtonTrigger(button);
          }
        }
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.id && node.id.startsWith('ProductSubmitButton-')) {
              setupButtonTrigger(node);
            }
          });
        }
      });
    });

    const productForm = document.querySelector('product-form');
    if (productForm) {
      observer.observe(productForm, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled']
      });
    }
  }

  function initFormSubmission() {
    const modal = document.getElementById('ec-modal-br');
    if (!modal) return;

    const form = modal.querySelector('form');
    const submitButton = modal.querySelector('#ec-br-form-modal-submit-btn');
    const successMessage = modal.querySelector('#ec-br-form-modal-success');

    function handleFormSuccess() {
      if (successMessage) {
        successMessage.style.display = 'block';
      } else {
        const successDiv = document.createElement('div');
        successDiv.className = 'ec-br-form-modal-success';
        successDiv.id = 'ec-br-form-modal-success';
        successDiv.innerHTML = '<p>Thank you! Your message has been sent successfully.</p>';
        if (form) {
          form.insertBefore(successDiv, form.firstChild);
        }
      }
      
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.innerHTML = 'Sent <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M6.07227 0.5L8.54846 2.97743L6.07227 5.45424" stroke="#F9F9F9" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.5 2.97656H8.54762" stroke="#F9F9F9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      }
      
      if (form) {
        const inputs = form.querySelectorAll('input, textarea');
        inputs.forEach(input => {
          input.disabled = true;
        });
      }
    }

    if (successMessage && successMessage.offsetParent !== null) {
      handleFormSuccess();
    }

    if (form && submitButton) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        submitButton.disabled = true;
        submitButton.innerHTML = 'Sending... <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M6.07227 0.5L8.54846 2.97743L6.07227 5.45424" stroke="#F9F9F9" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.5 2.97656H8.54762" stroke="#F9F9F9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        
        const formData = new FormData(form);
        
        fetch(form.action || window.location.href, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function(response) {
          return response.text();
        }).then(function(html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const errorMessages = doc.querySelector('.errors, .form-errors');
          
          if (!errorMessages) {
            handleFormSuccess();
          } else {
            const errorContainer = form.querySelector('.errors') || form.querySelector('.form-errors');
            if (errorContainer) {
              errorContainer.innerHTML = errorMessages.innerHTML;
            } else {
              form.insertBefore(errorMessages, form.firstChild);
            }
            submitButton.disabled = false;
            submitButton.innerHTML = 'Submit <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M6.07227 0.5L8.54846 2.97743L6.07227 5.45424" stroke="#F9F9F9" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.5 2.97656H8.54762" stroke="#F9F9F9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          }
        }).catch(function(error) {
          submitButton.disabled = false;
          submitButton.innerHTML = 'Submit <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M6.07227 0.5L8.54846 2.97743L6.07227 5.45424" stroke="#F9F9F9" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.5 2.97656H8.54762" stroke="#F9F9F9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        });
      });
    }
  }

  function initStockCheck() {
    
  }

  initModalTriggers();
  initFormSubmission();
  initStockCheck();

  document.addEventListener('shopify:section:load', function() {
    initModalTriggers();
    initFormSubmission();
    initStockCheck();
    isInitialLoad = true;
  });

  setTimeout(function() {
    isInitialLoad = false;
  }, 500);

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        if (event.data && event.data.variant) {
          checkVariantStock(event.data.variant);
        }
      });
    }
  }
});
